module.exports = __webpack_public_path__ + "img/chart_w.f6bae740.svg";